export default __webpack_public_path__ + "01fd9858550015ff064472a824244f95.jpg";